<template>
  <component :is="isMenu ? MenuItem : 'div'">
    <button
      class="flex h-7 w-7 items-center justify-center rounded-none border-none outline-none ring-white transition hover:shadow-md focus:border-none focus:ring-transparent"
      :class="`bg-entry-${color.color}-${color.color_type}`"
      :aria-pressed="checked"
    >
      <Transition name="scale">
        <i-heroicons-check v-if="checked" class="h-6 w-6" />
      </Transition>
    </button>
  </component>
</template>

<script lang="ts" setup>
import { MenuItem } from "@headlessui/vue";
import type { ColorPicker } from "~/types/ColorPicker";

withDefaults(
  defineProps<{
    color: ColorPicker;
    checked: boolean;
    isMenu?: boolean;
  }>(),
  {
    isMenu: false,
  }
);
</script>
